/**
 * _stellarnav.js
 * StellarNav1.0.0のカスタマイズ
 * @author Mitsutoshi Nakamura <mitsutoshi.nakamura.jp@gmail.com>
 */

class StellarNav {
  /**
   * リンククリックで画面遷移時にメニューを初期状態に戻す
   * @return void
   */
  mobileCloseOnTransition() {
    // デスクトップの場合はスルー
    if (!$('nav#main-nav').hasClass('mobile')) {
      return;
    }

    $('nav#main-nav ul a').not('.dd-toggle').on('touchstart', (e) => {
      const target = e.currentTarget;

      location.href = $(target).attr('href');
      $('nav#main-nav > ul > li.open > a.dd-toggle').trigger('click');
      $('nav#main-nav > a.menu-toggle').trigger('click');

      return false;
    });
  }
}

module.exports = new StellarNav();


// WEBPACK FOOTER //
// ./assets/js/_stellarnav.js